import * as types from "../../constants";

export default function reducer(state = {}, actions) {
  switch (actions.type) {
    case types.AUTH_SIGN_IN_SUCCESS:
      return {
        ...state,
        user: {
          username: actions.username,
          id: actions.id,
          afm: actions.afm,
          auth_level: actions.auth_level * 1,
          port_auth_id: actions.port_auth_id,
          port_auth: actions.port_auth,
          accessToken: actions.accessToken,
          gdpr_accept: actions.gdpr_accept,
          amka_verified: actions.amka_verified,
          birthyear: actions.birthyear,
          fathername: actions.fathername,
          firstname: actions.firstname,
          lastname: actions.lastname,
          mothername: actions.mothername,
        },
      };

    case types.UPDATE_USER_PORT_AUTH:
      return {
        ...state,
        user: { ...state.user, port_auth: actions.port_auth },
      };
    case types.AUTH_SIGN_OUT:
      return {
        ...state,
        user: undefined,
      };

    default:
      return state;
  }
}
